// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2iqos","fileBtn":"File_fileBtn__3WQz0","closeBtn":"File_closeBtn__2RSzK","fileSelected":"File_fileSelected__3EwFH","disabled":"File_disabled__mZ6sa"};